import React from "react";
import "./Solutions.css";

function Solutions() {
  return (
    <section id="solutions" className="solutions">
      <div className="container">
        <h2>Nossas Soluções</h2>
        <div className="solution-list">
          <div className="solution-item">
            <h3>Gestão Financeira</h3>
            <p>Ferramentas para controle e otimização do seu fluxo de caixa.</p>
          </div>
          <div className="solution-item">
            <h3>Linhas de Crédito</h3>
            <p>Acesso a crédito com condições exclusivas para impulsionar seu negócio.</p>
          </div>
          <div className="solution-item">
            <h3>Consultoria Financeira</h3>
            <p>Especialistas prontos para orientar e fortalecer sua gestão financeira.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Solutions;
